import { forwardRef } from 'react';
import { cva, cx } from 'class-variance-authority';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';
import { Button } from '../Button';

const filterButton = cva(['active:text-neutral-900'], {
  variants: {
    version: { 1: '', 2: '' },
    active: {
      true: [
        'bg-neutral-900',
        'text-white',
        'active:bg-neutral-700',
        'active:text-white',
        'focus:bg-neutral-700',
        'focus:text-white',
      ],
      false: ['text-primary-950'],
    },
  },
  compoundVariants: [
    {
      version: 2,
      active: true,
      class: [
        'bg-primary-700',
        'border-2',
        'border-transparent',

        'hover:!text-white',
        'hover:bg-primary-950',
        'hover:border-primary-950',

        'focus:bg-primary-700',
        'focus:text-white',
        'focus:!border-black',
        'focus:outline-white',
        'focus:outline-2',
        'focus:shadow-[0_0_0_6px_rgba(122,90,169,0.32)]',
        'focus:ring-2',
        'focus:ring-white',

        'active:border-primary-950',
        'active:bg-primary-950',
        'active:text-white',
      ],
    },
    {
      version: 2,
      active: false,
      class: [
        'bg-white',
        '!text-primary-700',
        'border-primary-700',
        'border-2',

        'hover:!text-white',
        'hover:bg-primary-950',
        'hover:border-primary-950',

        'focus:!border-black',
        'focus:bg-primary-700',
        'focus:!text-white',
        'focus:outline-white',
        'focus:outline-2',
        'focus:shadow-[0_0_0_6px_rgba(122,90,169,0.32)]',
        'focus:ring-2',
        'focus:ring-white',

        'active:bg-primary-950',
        'active:border-primary-950',
        'active:!text-white',
      ],
    },
  ],
  defaultVariants: { version: 1 },
});

export interface Filter {
  key: string;
  label: string;
  count?: number;
}

export type onFilterChange = (filter: Filter) => void;

type PageFilterButtonTypeMap = BaseTypeMap<
  'button',
  {
    active: boolean;
    label: string;
    count?: number;
    filterKey: string;
    version?: 1 | 2 | null;
    onFilterChange: onFilterChange;
  }
>;

export type PageFilterButtonProps = ComponentProps<PageFilterButtonTypeMap>;

export const PageFilterButton: Component<PageFilterButtonTypeMap> = forwardRef(
  function PageFilter(
    { active, version, label, count, filterKey, onFilterChange },
    ref
  ) {
    return (
      <Button
        as="button"
        ref={ref}
        key={filterKey}
        className={filterButton({ active, version })}
        onClick={() => onFilterChange({ key: filterKey, label, count })}
        intent="text"
      >
        {label} {count ? <span>({count})</span> : null}
      </Button>
    );
  }
);
